import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { telegramInitOptions } from "../utils/telegramInitOptions";

const TelegramContext = createContext(null);

export function TelegramProvider({ children }) {
  const [tg, setTg] = useState(null);
  const [isTelegram, setIsTelegram] = useState(false);
  const [tgReady, setTgReady] = useState(false);

  const historyStack = useRef([]);

  useEffect(() => {
    const webApp = window.Telegram?.WebApp;

    if (webApp && webApp.initData) {
      webApp.ready();

      telegramInitOptions(webApp, {
        headerColor: "#FFFFFF",
        backgroundColor: "#FFFFFF",
        expand: true,
        confirmClose: true,
      });

      setTg(webApp);
      setIsTelegram(true);
    } else {
      setIsTelegram(false);
      setTg(null);
    }

    setTgReady(true);
  }, []);

  // --- управление back ---
  const pushPage = (path) => {
    if (!isTelegram || !tg) return;

    const stack = historyStack.current;
    const last = stack[stack.length - 1];

    if (last !== path) {
      stack.push(path);
    }

    if (stack.length > 1) {
      tg.BackButton.show();
    } else {
      tg.BackButton.hide();
    }
  };

  const popPage = () => {
    if (!isTelegram || !tg) return;

    const stack = historyStack.current;
    stack.pop();

    if (stack.length > 1) {
      tg.BackButton.show();
    } else {
      tg.BackButton.hide();
    }
  };

  const value = useMemo(() => {
    if (!isTelegram || !tg) {
      return {
        isTelegram: false,
        pushPage: () => {},
        popPage: () => {},
      };
    }

    return {
      isTelegram: isTelegram,
      tg,
      initData: tg.initData,
      tgUser: tg.initDataUnsafe?.user ?? null,
      pushPage,
      popPage,
      tgReady
    };
  }, [isTelegram, tg]);

  return (
    <TelegramContext.Provider value={value}>
      {children}
    </TelegramContext.Provider>
  );
}

export function useTelegram() {
  const ctx = useContext(TelegramContext);
  if (!ctx) throw new Error("useTelegram must be used inside TelegramProvider");
  return ctx;
}
